module.exports = __webpack_public_path__ + "static/media/IC_home.a999b842.svg";